
import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useScoreboardState } from '@/hooks/useScoreboardState';

export default function RawXMLPage() {
  const { number } = useParams<{ number: string }>();
  const xmlRef = useRef<HTMLDivElement>(null);
  
  const {
    teamAScore,
    teamBScore,
    balls,
    strikes,
    outs,
    count,
    isTopInning,
    baseRunners,
    teamAName,
    teamBName,
  } = useScoreboardState(number || "");

  useEffect(() => {
    // Set content type to XML
    document.querySelector('meta[http-equiv="Content-Type"]')?.remove();
    const meta = document.createElement('meta');
    meta.setAttribute('http-equiv', 'Content-Type');
    meta.setAttribute('content', 'text/xml; charset=utf-8');
    document.head.appendChild(meta);
    
    // Create the XML document
    const data = [
      { title: "HomeTeam", value: teamBName || "Team B" },
      { title: "AwayTeam", value: teamAName || "Team A" },
      { title: "HomeScore", value: teamBScore.toString() },
      { title: "AwayScore", value: teamAScore.toString() },
      { title: "Inning", value: count === 99 ? "Final" : count.toString() },
      { title: "InningHalf", value: isTopInning ? "Top" : "Bottom" },
      { title: "Balls", value: balls.toString() },
      { title: "Strikes", value: strikes.toString() },
      { title: "Outs", value: outs.toString() },
      { title: "RunnerOnFirst", value: baseRunners[0] ? "1" : "0" },
      { title: "RunnerOnSecond", value: baseRunners[1] ? "1" : "0" },
      { title: "RunnerOnThird", value: baseRunners[2] ? "1" : "0" },
    ];

    let xml = '<?xml version="1.0" encoding="UTF-8"?>\n';
    xml += '<scoreboard>\n';
    
    data.forEach(item => {
      xml += `  <row>\n`;
      xml += `    <title>${item.title}</title>\n`;
      xml += `    <data>${item.value}</data>\n`;
      xml += `  </row>\n`;
    });
    
    xml += '</scoreboard>';
    
    // Set document content to XML only
    if (xmlRef.current) {
      xmlRef.current.textContent = xml;
      
      // If this is a direct XML request (not in an iframe or embedded), 
      // replace the entire document with just the XML
      if (window.location.pathname.includes('/xml/raw/kit/')) {
        document.body.innerHTML = '';
        document.write(xml);
        document.close();
      }
    }

    return () => {
      meta.remove();
    };
  }, [teamAScore, teamBScore, balls, strikes, outs, count, isTopInning, baseRunners, teamAName, teamBName]);

  return (
    <div ref={xmlRef} style={{ display: 'none' }}></div>
  );
}
